import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { InformationPageService } from 'src/app/services/informationPage.service';
import { BrowserStorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss']
})
export class PrivacyComponent implements OnInit {
  public regulationsHtml;
  constructor(private translate: TranslateService, private title: Title, private browserStorageService: BrowserStorageService, private pageService: InformationPageService) { }

  ngOnInit(): void {
    this.initContent(null);
    this.translate.onLangChange.subscribe(
      (lang: any) => { this.initContent(lang.lang); }
    );
    this.translate.get('privacy').subscribe({
      next: (title) => {
        this.title.setTitle(title);
      }
    });
  }

  private initContent(lang: string): void {
    if (lang == null) {
      lang = this.browserStorageService.get("_lang");
      if (lang == null || lang == '') {
        lang = 'pl';
      }
    }
    this.pageService.getInformationPage(this.pageService.PAGES.privacy, lang).subscribe((response: any) => {
      this.regulationsHtml = response.data.page[Object.keys(response.data.page)[0]];
    });
  }


}
